import { useEffect, useState, useLayoutEffect, useRef } from "react";
const ModalFooter = ({ children }) => {
  return (
    <div
      style={{
        padding: '16px 20px',
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '10px'
      }}
    >
      {children}
    </div>
  );
};


export default ModalFooter;
